<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="800">
    <v-card class="py-2">
      <v-card-title class="text-h5">
        <span class="ml-0">Logs</span>
        <v-spacer />
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-if="loading">
          <v-col cols="12" class="text-center">
            <v-progress-linear :active="true" :indeterminate="true" color="accent" />
          </v-col>
        </v-row>
        <v-row v-if="!loading">
          <v-col cols="12" class="pb-0">
            <v-textarea v-model="input" label="Input" readonly auto-grow rows="1" class="expand"></v-textarea>
          </v-col>
          <v-col cols="12" class="pt-0">
            <JsonViewer :value="logs" copyable></JsonViewer>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import JsonViewer from "vue-json-viewer";

export default {
  name: "AssistantLogModal",
  components: {
    JsonViewer,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    ticketId: {
      type: String,
      required: true,
    },
    input: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      logs: [],
    };
  },
  async created() {
    const response = await this.getAllTicketAssistantLogs({ id: this.ticketId, input: this.input });

    const logs = [];
    response.data.forEach((log) => {
      let formattedLog = log.log;
      try {
        // eslint-disable-next-line
        const validJsonString = formattedLog.replace(/'/g, '"');

        // Convertir a JSON válido
        formattedLog = JSON.parse(validJsonString);
      } catch (error) {
        console.log(error);
      }

      logs.push({
        assistant_name: log.assistant_name,
        type: log.type || "",
        log: formattedLog,
      });
    });

    this.logs = logs;
    this.loading = false;
  },
  methods: {
    ...mapActions(["getAllTicketAssistantLogs"]),
  },
};
</script>
